import React from 'react';
import './PolicyIndustrialismDescription.css';
import {CoinsStat} from "../../../PlayerStat/stats/CoinsStat";
import {
  POLICY_INDUSTRIALISM_BUILDING_DISCOUNT_PALACE,
  POLICY_INDUSTRIALISM_CONSTRUCTION_ACTIONS_BONUS,
} from "../../../../configs/policy/industrialism";
import DescriptionValueWithIcon from "../../DescriptionValueWithIcon/DescriptionValueWithIcon";

const PolicyIndustrialismDescription = () => {
  const discountElement = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/percent white.png'}
    alt={'Скидка'}
    title={'Скидка'}
  />;

  const actionIcon = <img
    className={'policy-description-icon'}
    src={'/img/icons/action.png'}
    alt={'Действие'}
    title={'Действие в Фазе Строительства'}
  />;

  const actionValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left'}
    value={`+${POLICY_INDUSTRIALISM_CONSTRUCTION_ACTIONS_BONUS}`}
    icon={actionIcon}
  />

  const palace = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right'}
    src={'/img/hexes/special buildings/palace.4b9c923b.png'}
    alt={'Дворец'}
    title={'Дворец'}
  />;

  const warehouse = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right'}
    src={'/img/hexes/special buildings/warehouse.adf397b3.png'}
    alt={'Склад'}
    title={'Склад'}
  />;

  const militaryCamp = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right'}
    src={'/img/hexes/special buildings/military camp.1216e2cd.png'}
    alt={'Лагерь'}
    title={'Лагерь'}
  />;

  const arsenal = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right'}
    src={'/img/hexes/special buildings/arsenal.7f5423b5.png'}
    alt={'Арсенал'}
    title={'Арсенал'}
  />;

  const fortress = <img
    className={'policy-description-icon-building'}
    src={'/img/hexes/special buildings/fortress button.6fed26ae.png'}
    alt={'Крепость'}
    title={'Крепость'}
  />;

  const buildingDiscount =
    <CoinsStat
      text={POLICY_INDUSTRIALISM_BUILDING_DISCOUNT_PALACE}
      noShrinkOnMobile={true}
      isDarkColor={true}
      className={'policy-description-icon-margin-left-end'}
    />;

  return (
    <>
      <div className={'policy-description_line'}>
        В
        <span className={'text-construction policy-description-icon-margin-left-end'}>
          фазе Строительства
        </span>
        {actionValueAndIcon}.
      </div>
      <div className={'policy-description_line policy-description_line-margin-top-paragraph-large'}>
        {palace}{warehouse}{militaryCamp}{arsenal}{fortress}
      </div>
      <div className={'policy-description_line policy-description_line-margin-top'}>
        дешевле {discountElement} на {buildingDiscount}.
      </div>
    </>
  );
};

export default PolicyIndustrialismDescription;
